
import {single} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';




const httpOptions = {
    // headers: new HttpHeaders({'Content-Type': 'text/plain'})
    headers: new HttpHeaders({'Content-Type': 'application/json'}),
    timeout: 0
};

@Injectable()
export class NewClientOrdersService {

    constructor(private authService: AuthService, private http: HttpClient) {
    }

    public getNewClientOrders(clientCode: string, apiID: number): Promise<object> {
        if (this.authService.user.hasRole('employee')) {
            var body = {
                'clientCode': clientCode,
                'apiID': apiID
            };
            // var retVal = this.http.post('/api/service/newRequests/', body, httpOptions).toPromise();
            var retVal = this.http.post('/api/service/newClientOrders/', body, httpOptions).pipe(single()).toPromise();
        }
        return retVal;
    }

}
